import { z } from '@harvestiq/zod';
import { lrpQuoteSchema } from '@harvestiq/usda-common';
import { lgmSingleHeadQuoteSchema } from '@harvestiq/usda-common/lgm-helpers/lgm-single-head-quote';

export const rmaQuoteSchema = z.union([
  lrpQuoteSchema,
  lgmSingleHeadQuoteSchema,
]);
export type RmaQuote = z.infer<typeof rmaQuoteSchema>;
